module.exports = __webpack_public_path__ + "static/media/listing-page-generic.92ad0404.jpg";